import { Viewer } from "@equiem/web-ng-lib";
import React, { PropsWithChildren } from "react";
import { useAuthenticatedViewer } from "../hooks/useAuthenticatedViewer";

export const ViewerProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const viewer = useAuthenticatedViewer();

  return (
    <Viewer.Provider value={viewer}>{children}</Viewer.Provider>
  );
};
